import React from "react";

const FormTitle = () => {

  return (
    <div className="
      flex w-full h-[3rem] bg-primary rounded-t-md justify-center items-center
      text-lg font-medium
    ">
      <p className="font-semibold">BÀI TRẮC NGHIỆM DIAG HUB</p>
    </div>
  )
}

export default FormTitle
